export const CursosList = [
    {
        value: "grau-mitja",
        label: "Cicle Formatiu de Grau Mitjà",
        children: [
            { value: "1SMX", label: "1r de SMX" },
            { value: "2SMX", label: "2n de SMX" },
        ],
    },
    {
        value: "grau-superior",
        label: "Cicle Formatiu de Grau Superior",
        children: [
            { value: "1DAM", label: "1r de DAM" },
            { value: "2DAM", label: "2n de DAM" },
            { value: "1DAW", label: "1r de DAW" },
            { value: "2DAW", label: "2n de DAW" },
            { value: "1ASIX", label: "1r de ASIX" },
            { value: "2ASIX", label: "2n de ASIX" },
            { value: "CE", label: "Máster FP" },
        ],
    },
    {
        value: "universitat",
        label: "Grau Universitari",
        children: [
            { value: "1FONAMENTS", label: "Fonaments de Física" },
            { value: "ITIC", label: "ITIC" },
            { value: "RM", label: "Research Methods" },
            { value: "GEBM", label: "Grau d'Enginyeria Biomèdica" },
        ],
    },
];
